/* eslint-disable react-hooks/exhaustive-deps */
import { CheckCircle2, Sparkles } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFlowManager } from "../../../hooks/useFlowManager";

const PostSuccessPage = () => {
  const [count, setCount] = useState(5);
  const navigate = useNavigate();
  const { goToDashboard } = useFlowManager();

  useEffect(() => {
    let timer = setInterval(() => {
      setCount((c) => Math.max(c - 1, 0));
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (count === 0) {
      goToDashboard();
    }
  }, [count]);

  useState(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-white to-green-100 flex flex-col items-center justify-center px-4 py-10 text-center">
      {/* Graphic */}
      <div className="mb-6 relative flex items-center justify-center">
        <div className="absolute inset-0 blur-2xl bg-green-300/30 rounded-full w-40 h-40" />
        <CheckCircle2 className="w-28 h-28 text-green-600 relative drop-shadow-xl" />
      </div>

      {/* Title */}
      <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3 tracking-tight">
        Property Posted Successfully!
      </h2>

      {/* Message */}
      <p className="text-gray-600 max-w-lg text-center leading-relaxed px-2">
        Your listing is now active and ready to attract buyers. Thanks for
        trusting <span className="text-green-600 font-semibold">Leadbook</span>.
        We're here to amplify your success.
      </p>

      {/* Celebration Icons */}
      <div className="mt-8 flex gap-4 opacity-90">
        <Sparkles className="w-8 h-8 text-green-600" />
        <Sparkles className="w-6 h-6 text-green-600" />
        <Sparkles className="w-8 h-8 text-green-600" />
      </div>

      {/* Countdown */}
      <p className="text-gray-800 mt-10 text-lg font-medium">
        Redirecting to dashboard in{" "}
        <span className="text-green-600 font-bold">{count}</span> seconds…
      </p>

      {/* Manual Button */}
      <button
        className="
          mt-6 px-8 py-3 rounded-full border-2 border-green-600 text-green-600 
          hover:bg-green-600 hover:text-white active:scale-95 transition-all font-medium
        "
        onClick={() => navigate("/admin/properties", { replace: true })}
      >
        Go to Dashboard Now
      </button>
    </div>
  );
};

export default PostSuccessPage;
